export default __webpack_public_path__ + "static/media/alex.23515c8d.png";